import React from "react";
import { View, Text, StyleSheet, TextStyle, ViewStyle } from "react-native";
import { Colors, Spacing } from "@constants";

interface IProps {
  items: string[];
  bulletColor?: string;
  textColor?: string;
  fontSize?: number;
  spacing?: number;
  bulletChar?: string;
  style?: ViewStyle;
  textStyle?: TextStyle;
  bulletStyle?: TextStyle;
}

export const InfoList: React.FC<IProps> = ({
  items,
  bulletColor = Colors.foodiDefault,
  textColor = Colors.foodiBlack,
  fontSize = 14,
  spacing = Spacing.M,
  bulletChar = "•",
  style,
  textStyle,
  bulletStyle,
}) => {
  const styles = StyleSheet.create({
    container: {
      paddingVertical: Spacing.S,
      paddingHorizontal: Spacing.M,
    },
    bulletItem: {
      flexDirection: "row",
      alignItems: "flex-start",
      marginBottom: spacing,
    },
    bulletPoint: {
      color: bulletColor,
      fontSize: fontSize + 2,
      fontWeight: "bold",
      marginRight: Spacing.S,
      lineHeight: fontSize + 8,
      ...bulletStyle,
    },
    bulletText: {
      flex: 1,
      color: textColor,
      fontSize,
      lineHeight: fontSize + 6,
      ...textStyle,
    },
  });

  return (
    <View style={[styles.container, style]}>
      {items.map((item, index) => (
        <View key={index} style={[styles.bulletItem]}>
          <Text style={styles.bulletPoint}>{bulletChar}</Text>
          <Text style={styles.bulletText}>{item}</Text>
        </View>
      ))}
    </View>
  );
};
